export const data = {
  cpsp_store: "cpsp-store"
};
export const get = function(k) {
  if (sessionStorage.getItem(k)) return sessionStorage.getItem(k);
};
export const set = function(k, v) {
  return sessionStorage.setItem(k, v);
};
export const clear = function() {
  sessionStorage.clear();
};
